// ============================================================================
// Constantes de negocio — Cotizador Programmatic
// ============================================================================

// --- Meses ---
export const MESES = [
  { value: "1", label: "ENE" },
  { value: "2", label: "FEB" },
  { value: "3", label: "MAR" },
  { value: "4", label: "ABR" },
  { value: "5", label: "MAY" },
  { value: "6", label: "JUN" },
  { value: "7", label: "JUL" },
  { value: "8", label: "AGO" },
  { value: "9", label: "SEP" },
  { value: "10", label: "OCT" },
  { value: "11", label: "NOV" },
  { value: "12", label: "DIC" },
];

// --- Locale por país (para toLocaleString) ---
export const LOCALE_POR_PAIS = {
  Chile: "es-CL",
  Perú: "es-PE",
  Uruguay: "es-UY",
};

// --- Audiencia y contactos ---
export const TRAYECTOS_PROMEDIO_DIA = 7.48;

// Distribución de contactos por franja horaria (suman 1.0)
export const DISTRIBUCION_FRANJAS = {
  valle: 0.15,
  picoMañana: 0.25,
  picoMediodia: 0.35,
  picoTarde: 0.25,
};

// Horas por franja (para calcular contactos por hora)
export const HORAS_POR_FRANJA = {
  valle: 8,
  picoMañana: 2,
  picoMediodia: 2,
  picoTarde: 2,
};

// --- Intervalos horarios ---
export const INTERVALOS_MANANA = ["08:00 - 08:30", "08:30 - 09:00", "09:00 - 09:30", "09:30 - 10:00"];
export const INTERVALOS_MEDIODIA = ["12:30 - 13:00", "13:00 - 13:30", "13:30 - 14:00", "14:00 - 14:30"];
export const INTERVALOS_TARDE = ["17:00 - 17:30", "17:30 - 18:00", "18:00 - 18:30", "18:30 - 19:00"];

// --- Coeficientes de frecuencia (frecuencia × franja → factor) ---
export const COEFICIENTES_FRECUENCIA = {
  5: { valle: 0.0556, picoMañana: 0.1042, picoMediodia: 0.125, picoTarde: 0.1042 },
  10: { valle: 0.1111, picoMañana: 0.2083, picoMediodia: 0.25, picoTarde: 0.2083 },
  15: { valle: 0.1667, picoMañana: 0.3125, picoMediodia: 0.375, picoTarde: 0.3125 },
  20: { valle: 0.2222, picoMañana: 0.4167, picoMediodia: 0.5, picoTarde: 0.4167 },
  25: { valle: 0.2778, picoMañana: 0.5208, picoMediodia: 0.625, picoTarde: 0.5208 },
  30: { valle: 0.3333, picoMañana: 0.625, picoMediodia: 0.75, picoTarde: 0.625 },
};

// --- CPM ---
export const CPM_REFERENCIA_BASE = 6.9;

// Incidencia por duración del spot (duración en seg → factor multiplicador del CPM)
export const DURACION_INCIDENCIA = {
  6: 1,
  7: 1.0125,
  8: 1.025,
  9: 1.0375,
  10: 1.05,
  11: 1.0625,
  12: 1.075,
  13: 1.0875,
  14: 1.1,
  15: 1.1125,
};

// Multiplicador por tipo de campaña
export const MULTIPLICADOR_TIPO_CAMPANA = {
  intervalos: 2.5,
  amPm: 1.5,
  full: 1,
};

// CPM de otros circuitos relativo al de ascensores
export const CPM_RATIO_OTROS_CIRCUITOS = 0.9;

// --- Descuentos ---

// Descuento por duración del spot
export const DESCUENTO_DURACION = {
  6: 0.01,
  7: 0.0115,
  8: 0.0125,
  9: 0.0135,
  10: 0.0145,
  11: 0.0155,
  12: 0.0165,
  13: 0.0175,
  14: 0.0185,
  15: 0.0195,
};

// Bonus de duración larga + horas largas (duracion > 12 && horas > 12)
export const BONUS_DURACION_HORAS_LARGAS = 0.1;

// Descuento por inventario (% pantallas seleccionadas del total)
export const DESCUENTO_MAXIMO_INVENTARIO = 0.075;
export const INVENTARIO_RATIO_MINIMO = 0.5; // por debajo se penaliza al 50%

// Descuento por plazo
export const DESCUENTO_MAXIMO_PLAZO = 0.06;
export const TAU_AMORTIGUAMIENTO = 120;
export const PLAZO_MAXIMO_EFECTIVO = 260;
export const PLAZO_MINIMO_DESCUENTO = 0.005; // mínimo si plazo < 20
export const PLAZO_INVENTARIO_BONUS = 1.25; // invRatio > 0.7 && plazo > 60

// Descuento por frecuencia
export const FRECUENCIA_BASE_DESCUENTO = 0.02;
export const FRECUENCIA_INCREMENTO = 0.02;
export const FRECUENCIA_FACTOR_REDUCCION = 0.9;
export const FRECUENCIA_DIVISOR_HORAS_7 = 2.2; // si horas = 7, se divide por esto

// Bono frecuencia × plazo
export const BONO_FREQ_PLAZO_MULTIPLICADOR = 1.15; // si bonoFreqPlazo > 0 && (plazo > 60 || invRatio > 0.7)
export const PENALIZACION_FREQ_INADECUADA = 0.9; // si freq < 15 && plazo > 60

// Tope del descuento global
export const CAP_DESCUENTO_BASE = 0.2;

// Factor de escala por país (reduce el descuento global)
export const SCALE_FACTOR_PAIS = {
  Chile: 0.25,
  Perú: 0.5,
  Region: 1,
};
